import { ErrorMessage } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';

import './CheckboxField.styles.css';

const CheckboxField = ({ Labels, Type, Name, Value, Class,
  onChange,
  onBlur,
}) => {

  return (
    <>
      <Form.Check
        type={Type}
        id={`default-${Labels}`}
        label={Labels}
        value={Value}
        name={Name}
        onChange={onChange}
        onBlur={onBlur}
        className={Class}
      />
      { //<ErrorMessage name={Name} component="div" style={{ color: 'red', marginBottom: '5px' }} />
      }    </>
  );
};

export default CheckboxField;
